import { GatsbyImage, StaticImage } from 'gatsby-plugin-image'
import React from 'react'
import { IEmployeeStory } from '../interfaces/IEmployeeStory'
import { Heading } from './Heading'
import { Quotes } from './Icons'

interface EmployeeStoriesListProps {
  stories: readonly IEmployeeStory[] | null
  smallQuoteFont?: boolean
}

export const EmployeeStoriesList = ({
  stories,
  smallQuoteFont = false,
}: EmployeeStoriesListProps) => {
  return (
    <div className="grid gap-16">
      {stories &&
        stories.map((story: IEmployeeStory, index: number) => {
          const isEven = index % 2

          return (
            <div
              className={`grid gap-2 md:gap-8 justify-items-center md:justify-items-start items-center ${
                isEven ? 'md:grid-cols-[1fr,auto]' : 'md:grid-cols-[auto,1fr]'
              }`}
            >
              <div
                className={`grid content-center md:w-[320px] md:h-[480px] bg-white ${
                  isEven ? 'md:order-1' : 'md:order-0'
                } rounded`}
              >
                {story &&
                  story.featuredImage &&
                  story.featuredImage.node &&
                  story.featuredImage.node.gatsbyImage && (
                    <GatsbyImage
                      className="rounded overflow-hidden"
                      image={story.featuredImage.node.gatsbyImage}
                      alt={story.title || ''}
                    />
                  )}

                {!story.featuredImage && (
                  <StaticImage
                    src="../images/silueta.jpg"
                    alt=""
                    class="relative max-w-full z-10"
                  />
                )}
              </div>

              <div className="grid gap-4 md:gap-8">
                <div className="grid gap-1">
                  <Heading
                    as="h3"
                    className="font-medium text-2xl lg:text-3xl text-primary"
                  >
                    {story.title}
                  </Heading>

                  {story.details?.position && (
                    <p className="text-secondary">{story.details?.position}</p>
                  )}
                </div>

                {story.details?.employeeStory?.quote && (
                  <div
                    className={`relative p-6 bg-[#fffaf0] ${
                      smallQuoteFont ? 'md:text-base' : 'md:text-lg'
                    } rounded`}
                  >
                    <span className="absolute top-5 left-3">
                      <Quotes />
                    </span>
                    <span className="relative">
                      {story.details?.employeeStory?.quote}
                    </span>
                  </div>
                )}

                {story.details?.employeeStory?.story && (
                  <div
                    className=""
                    dangerouslySetInnerHTML={{
                      __html: story.details?.employeeStory?.story,
                    }}
                  />
                )}
              </div>
            </div>
          )
        })}
    </div>
  )
}
